import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';

import { url } from '@api-config';

export const solutionQueryKey = ['solutionList'];

export type ISolution = {
  id: number;
  modelId: number;
  name: string;
  graphUri: string;
};

export const initialData: ISolution[] = [];
export const initialSolution: ISolution = { id: -1, modelId: -1, name: '', graphUri: '' };

/**
 * Hooks to fetch the list of solutions
 * @returns ISolution[]
 */
export const useSolutionList = (): UseQueryResult<ISolution[], Error> & { solution: ISolution } => {
  const solutionListQuery = useQuery<ISolution[], Error>({
    queryKey: solutionQueryKey,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get(url.solution);
      const data = response.data;

      return data;
    },
  });

  return { ...solutionListQuery, solution: solutionListQuery?.data?.[0] || initialSolution };
};
